import moment from 'moment'

function GetTimeStamp () {
  const currentTime = moment().format('YYYY/MM/DD HH:mm:ss')
  return currentTime
}

function getExpirationAt () {
  return moment().add(process.env.REACT_APP_CREDENTIAL_EXPIRE_AMOUNT, process.env.REACT_APP_CREDENTIAL_EXPIRE_UNIT).format('YYYY/MM/DD HH:mm:ss')
}

export { GetTimeStamp, getExpirationAt }
